<template>
  <v-main>
    <v-container
      fluid
      class="grey lighten-4 pa-xs-5 pa-sm-5 pa-md-10 pa-lg-10 pa-xl-10"
      style="height: auto;"
    >
      <v-card
        rounded="lg"
        elevation="6"
        height="100%"
        outlined
        class="ma-xs-5 ma-sm-5 ma-md-5 ma-lg-10 ma-xl-10 pa-5"
      >
        <v-card-title class="justify-start d-flex align-center">
          <p class="my-auto text-h4 font-weight-bold primary--text">
            Admin Page
          </p>
        </v-card-title>
        <hr class="my-4" />

        <v-tabs
          v-model="adminSection"
          background-color="primary"
          centered
          dark
          icons-and-text
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab>
            Contact Us Submissions
            <v-icon>contact_mail</v-icon>
          </v-tab>

          <v-tab>
            Reported Comments
            <v-icon>report_problem</v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="adminSection">
          <v-tab-item>
            <ContactUsSubmissions />
          </v-tab-item>

          <v-tab-item>
            <ReportComments />
          </v-tab-item>

        </v-tabs-items>

      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import ContactUsSubmissions from '@/components/Admin/ContactUsSubmissions.vue'
import ReportComments from '@/components/Admin/ReportComments.vue'
import { formatToElapsedTime } from '@/utils/date'

export default {
  name: 'Admin',
  components: {
    ContactUsSubmissions,
    ReportComments
  },
  async created() {
    if (!this.user) {
      this.$router.replace({ name: 'Forum' })
      return
    }
  },
  data: () => ({
    search: null,
    adminSection: ''
  }),
  computed: {
    messages() {
      const messages = this.$store.getters['contact_us/ALL']
      return messages.map((message) => ({
        id: message.id,
        name: message.name,
        email: message.email,
        createdAt: formatToElapsedTime(message.createdAt),
        body: message.body
      }))
    },
    messagesToDisplay() {
      const messages = [...this.messages]
      if (this.search) {
        const search = this.search.toLowerCase()
        return messages.filter(
          (message) =>
            message.name.toLowerCase().includes(search) ||
            message.email.toLowerCase().includes(search) ||
            message.body.toLowerCase().includes(search)
        )
      }

      return messages
    },
    user() {
      return this.$store.getters['users/AUTH_USER']
    }
  },
  methods: {

  },
  watch: {
    user(val) {
      if (!val) {
        this.$router.replace({ name: 'Forum' })
      }
    }
  }
}
</script>

<style></style>
